var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9844 36C23.7583 36 28.3366 34.1036 31.7123 30.7279C35.088 27.3523 36.9844 22.7739 36.9844 18C36.9844 13.2261 35.088 8.64773 31.7123 5.27208C28.3366 1.89642 23.7583 0 18.9844 0C14.2105 0 9.63211 1.89642 6.25645 5.27208C2.8808 8.64773 0.984375 13.2261 0.984375 18C0.984375 22.7739 2.8808 27.3523 6.25645 30.7279C9.63211 34.1036 14.2105 36 18.9844 36ZM26.9297 14.6953L17.9297 23.6953C17.2687 24.3563 16.2 24.3563 15.5461 23.6953L11.0461 19.1953C10.3852 18.5344 10.3852 17.4656 11.0461 16.8117C11.707 16.1578 12.7758 16.1508 13.4297 16.8117L16.7344 20.1164L24.5391 12.3047C25.2 11.6438 26.2687 11.6438 26.9227 12.3047C27.5766 12.9656 27.5836 14.0344 26.9227 14.6883L26.9297 14.6953Z",
    fill: "#2E4A24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circleCheck.89caad40eeddb29482d9c616fff417ca.svg";
export { ForwardRef as ReactComponent };